import script from "./YImage.vue?vue&type=script&setup=true&lang=js"
export * from "./YImage.vue?vue&type=script&setup=true&lang=js"

import "./YImage.vue?vue&type=style&index=0&id=319fdaea&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319fdaea"]])

export default __exports__